import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Droplets, Shield, Sparkles, Award } from "lucide-react";
import { companyInfo } from "@/data/products";

const HeroSection = () => {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden">
      {/* Hero Background Image */}
      <div className="absolute inset-0">
        <img 
          src="/images/hero-banner.jpg" 
          alt="PurePro India premium water ionizer and RO systems hero banner"
          className="w-full h-full object-cover"
          fetchPriority="high"
          loading="eager"
          width={1920}
          height={1080}
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary/90 via-primary/70 to-primary/40" />
      </div>

      <div className="container-premium relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-center lg:text-left animate-fade-in">
            <div className="inline-flex items-center gap-2 bg-accent/20 text-accent px-4 py-2 rounded-full text-sm font-medium mb-6 backdrop-blur-sm">
              <Award className="w-4 h-4" />
              {companyInfo.tagline}
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-white leading-tight mb-6">
              Pure Water,{" "}
              <span className="text-gradient-cyan">Healthy Life</span>
            </h1>

            <p className="text-lg md:text-xl text-white/90 mb-8 max-w-xl mx-auto lg:mx-0">
              Experience premium water ionizers and RO systems from {companyInfo.name}. {companyInfo.madeIn} - trusted by thousands of families across India.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button asChild className="btn-cyan text-base h-12 px-8 border-0 group">
                <Link to="/products">
                  View Products
                  <ArrowRight className="w-5 h-5 ml-2" />
                </Link>
              </Button>
              <Button asChild variant="outline" className="h-12 px-8 text-base border-2 border-white/50 bg-white/10 text-white hover:bg-white hover:text-primary backdrop-blur-sm transition-all duration-300">
                <Link to="/contact-us">
                  Contact Us
                </Link>
              </Button>
            </div>

            {/* Trust Badges */}
            <div className="mt-12 flex flex-wrap gap-4 justify-center lg:justify-start">
              {[
                { icon: Shield, label: "Made in USA" },
                { icon: Droplets, label: "20+ Years Expertise" },
                { icon: Sparkles, label: "1M+ Systems" },
              ].map((badge) => (
                <div
                  key={badge.label}
                  className="flex items-center gap-2 text-white/90 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full cursor-default"
                >
                  <badge.icon className="w-5 h-5 text-accent" />
                  <span className="text-sm font-medium">{badge.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Aqua Wave Bottom */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 120" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg" 
          className="w-full h-auto"
          aria-hidden="true"
          role="presentation"
        >
          <path 
            d="M0,120 L60,105 C120,90 240,60 360,45 C480,30 600,30 720,37.5 C840,45 960,60 1080,67.5 C1200,75 1320,75 1380,75 L1440,75 L1440,120 L1380,120 C1320,120 1200,120 1080,120 C960,120 840,120 720,120 C600,120 480,120 360,120 C240,120 120,120 60,120 L0,120 Z" 
            fill="hsl(var(--accent))"
          />
        </svg>
      </div>
    </section>
  );
};

export default HeroSection;
